<template>
    <div class="cz3__form-fields"
        :class="{
            'cz3__form-fields--no-padding': noPadding,
        }"
    >
        <slot/>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__form-fields {
            flex: 1 1 0;

            display: flex;
            flex-direction: column;

            padding: 0 16px 16px;

            gap: 16px;

            @include respond-above(sm) {
                padding: 0 32px 40px;

                gap: 26px;

                // &.cz3__form-fields--no-padding {
                padding: 0;

                // TODO: Fix nested hack.
                .cz3__form-fields {
                    padding-bottom: 0;
                }
                // }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            noPadding: Boolean,
        },
    };
</script>
